__turbopack_context__.v({
  "actionBtn": "MemberSelector-module__FxHGAa__actionBtn",
  "active": "MemberSelector-module__FxHGAa__active",
  "arrowContainer": "MemberSelector-module__FxHGAa__arrowContainer",
  "container": "MemberSelector-module__FxHGAa__container",
  "footer": "MemberSelector-module__FxHGAa__footer",
  "item": "MemberSelector-module__FxHGAa__item",
  "itemActions": "MemberSelector-module__FxHGAa__itemActions",
  "itemLabel": "MemberSelector-module__FxHGAa__itemLabel",
  "list": "MemberSelector-module__FxHGAa__list",
  "popIn": "MemberSelector-module__FxHGAa__popIn",
  "popoverContent": "MemberSelector-module__FxHGAa__popoverContent",
  "trigger": "MemberSelector-module__FxHGAa__trigger",
  "unassigned": "MemberSelector-module__FxHGAa__unassigned",
  "value": "MemberSelector-module__FxHGAa__value",
});
